<div class="d-flex flex-row">
    <p class="flex-grow-1 m-0">AWB: {{ awb }}</p>
    <span class="item-fee-value mb-0"> {{ total | currency }} </span>
</div>
